<template>
  <el-dialog
    title="检查清单"
    :visible.sync="dialogVisible"
    append-to-body
    @close="closeForm"
    width="1200px">
    <el-radio-group size="small" @change="changeType" v-model="type" style="margin: 0 0 0px 20px;">
      <el-radio-button :label="1">行业领域检查清单</el-radio-button>
      <el-radio-button :label="4">网格员检查导则</el-radio-button>
      <el-radio-button :label="2">专项检查清单</el-radio-button>
      <el-radio-button :label="3">重大隐患检查清单</el-radio-button>
      <el-radio-button :label="5">主体责任检查清单</el-radio-button>
    </el-radio-group>
    <div style="padding: 0px 0px 20px 20px" class="table-container">
      <div style="width: 100%;" class="fl-wrap mg-tp-sm">
        <div class="search-item">
          <span class="span">{{title}}名称</span>
          <el-input clearable size="mini" style="width:300px;margin-right:15px" v-model="searchForm.name"  class="item" :placeholder="`请输入${title}名称`"></el-input>
        </div>
        <div v-if="type != 4" class="search-item">
          <span class="span">适用行业类型</span>
          <el-cascader
          size="mini"
          clearable
          @clear="searchForm.control_id=null"
          v-model="searchForm.control_id"
          :options="industryOptions"
          ></el-cascader>
        </div>
        <div class="search-item">
          <span class="span">上传部门</span>
          <el-cascader
            size="mini"
            ref="departmentTree"
            :show-all-levels="false"
            v-model="searchForm.create_department"
            @change="change"
            :options="departmentData"
            :props="{ checkStrictly: true, label: 'name', value: 'id' }"
            clearable></el-cascader>
        </div>
        <div class="search-item">
          <span class="span">上传时间</span>
          <el-date-picker
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="margin-right:15px;"
            size="mini"
            v-model="Daterange"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </div>
      </div>
      <div style="width: 100%;display: flex" class="fl-wrap mg-tp-sm">
        <el-button class="search-item" @click="reset" style="height:28px" size="mini" type="primary">重置</el-button>
        <el-button class="search-item" @click="search" style="height:28px;margin-left: 5px;" size="mini" type="primary">查询</el-button>
        <el-button class="search-item" @click="save" style="height:28px;margin-left: 5px;" size="mini" type="primary">确 定</el-button>
      </div>
      <div class="ruleform">
        <div style="" class="table">
          <div style="font-size: 18px;margin-bottom:10px;display:flex;align-items:center"></div>
        </div>
        <el-table
          :data="tableData"
          @select="select"
          @select-all="selectAll"
          @cell-dblclick="tableDbEdit"
          highlight-current-row
          @current-change="currentChange"
          v-loading="loading"
          style="color:#303133;width: 100%; margin-bottom: 10px"
          :header-cell-style="{padding: '8px 0',color: '#303133',backgroundColor: 'rgb(240,245,251)'}"
          border
          stripe>
          <el-table-column
            type="selection"
            v-if="selectType == 'multiple'"
            width="55">
          </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="50">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="name"
            :label="title">
          </el-table-column>
          <el-table-column
            prop="count"
            label="检查项数"
            width="90">
          </el-table-column>
          <el-table-column
            v-if="type != 4"
            show-overflow-tooltip
            prop="control_name"
            label="适用行业类型">
            <template slot-scope="{row}">
              {{ row.control_name || '-' }}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="create_department"
            label="上传部门">
            <template slot-scope="{row}">
              {{ row.create_department || '-' }}
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            prop="is_default"
            label="是否在企业端展示">
            <template slot-scope="{row}">
              {{row.is_default == 1 ? '是' : '否'}}
            </template>
          </el-table-column>
          <el-table-column
            width="180"
            :formatter="row => row.create_time || '-'"
            prop="create_time"
            label="上传时间">
          </el-table-column>
          <el-table-column
            :formatter="row => row.update_date || '-'"
            prop="update_date"
            label="更新时间">
          </el-table-column>
        </el-table>
        <el-row v-if="pagination" style="width: 100%">
          <el-col :span="24">
            <div style="float:right;padding:10px">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="10"
                layout="total, prev, pager, next, jumper"
                :total="totalCount">
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
    </span>
  </el-dialog>
  </template>

  <script>
  import {industryOptions} from '@/Util/commonOptions'
  import * as types from '@/vuex/types'
  import store from '@/vuex/store'
  import Search from '@/Util/Search'
  import {api} from '@/api/api'
  import table1 from './table1'
  // import {tableMixins} from '@/mixins/qiboMixins'

  export default {
    components: {
      Search,
      table1,
    },
    // mixins: [tableMixins],
    data () {
      return {
        type: 1,
        title:"行业领域检查清单",
        industryOptions, //适用行业类型选项
        departmentData: [], //上传部门选项
        Daterange: [], //上传时间
        searchForm:{
          name: null,
          control_id: null,
          create_department: null,
        },
        pagination: true,
        totalCount: null,
        currentPage:1,
        selectType: 'select',
        dialogVisible: true,
        loading: false,
        jobOptions: [],
        tableData: [],
        treeData: [], // 员工树
        checkedData: null, // 选中的节点
        totalCount: 0,
        parent_node_id: 0, // 父级ID
        parent_node_label: null, // 父级名称
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        callback: null,
        job_id: null,
        SelectionAll: {},
        SelectionTable: [],
        list: null,
      }
    },
    mounted () {
      this.getList()
      this.getDepartmentTreeList()
    },
    methods: {
      changeType() {
        switch(this.type){
          case 1:this.title='行业领域检查清单';break;
          case 2:this.title='专项检查清单';break;
          case 3:this.title='重大隐患检查清单';break;
          case 4:this.title='网格员检查导则';break;
          case 5:this.title='主体责任检查清单';break;
        }
        this.reset()
        this.getList()
      },
      // treeCheck (val) {
      //   let data = this.$refs['tree'].getCheckedKeys(true)
      //   this.treeId = data.join(',')
      //   this.getList()
      // },

      //多选 --begin
      select (selection, row) {
        for (let key in this.SelectionAll) {
          if (key == row.id) {
            delete this.SelectionAll[key]
            this.SelectionTable = Object.values(this.SelectionAll)
            return
          }
        }
        this.SelectionAll[row.id] = row
        this.SelectionTable = Object.values(this.SelectionAll)
      },
      selectAll (select) {
        for (let row of this.tableData) {
          if (select.length === 0) {
            delete this.SelectionAll[row.id]
          } else {
            this.SelectionAll[row.id] = row
          }
        }
        this.SelectionTable = Object.values(this.SelectionAll)
      },
      //多选 --end

      currentChange (currentRow) {
        if (currentRow) {
          this.list = currentRow
        }
      },
      //双击事件
      tableDbEdit(){
        if (this.selectType == 'select') {
          this.save()
        }
      },
      closeForm () {
        this.list = null
        // this.checkedData = null
        // this.$refs['table'].setCurrentRow()
        // this.$el.parentNode.removeChild(this.$el);
      },
      save () {
        if (this.selectType == 'multiple') {
          this.saveMultiple()
        } else {
          this.saveSingle()
        }
      },
      saveSingle () {
        if (!this.list) {
          return this.$message({
            type: 'warning',
            message: '请选择清单'
          })
        }
        if (this.callback && typeof(this.callback) === 'function') {
          this.callback([this.list])
        }
        this.dialogVisible = false
      },
      saveMultiple () {
        if (this.SelectionTable.length == 0) {
          return this.$message({
            type: 'warning',
            message: '请选择清单'
          })
        }
        if (this.callback && typeof(this.callback) === 'function') {
          this.callback(this.SelectionTable)
        }
        this.dialogVisible = false
      },
      showForm () {
        this.dialogVisible = true
      },
      // 获取列表
      getList (currentPage) {
        this.loading = true
        let params = {
          page_index: 1,
          page_size: 10,
          // control_ids: this.treeId,
          type: this.type
        }
        if (this.pagination) {
          params.page_index = currentPage
          params.page_size = 10
        }
        if (this.handleNewParams) {
          let myParams = this.handleNewParams()
          for (let key in myParams) {
            params[key] = myParams[key]
          }
        }
        this.$http.post(
          api['getCheckTableDBList'],
          params
        ).then(response => {
          this.tableData = response.data.data
          if (this.selectType == 'multiple') {
            this.$nextTick(() => {
              this.checkSelect()
            })
          }
          if (this.pagination && this.tableData.length > 0) {
            this.totalCount = response.data.page_info.total_num
          } else {
            this.totalCount = 0
          }
          setTimeout(() => {
            this.loading = false
          }, 400)
        }).catch((error) => {
          console.log(error)
        })
      },
      // 每次刷新时检查是否有选项，并设置已选中
      checkSelect () {
        for (let row of this.tableData) {
          if (this.SelectionAll.hasOwnProperty(row.id)) {
            this.$refs.table.toggleRowSelection(row,true)
          }
        }
      },
      //查询-上传部门
      getDepartmentTreeList () {
        this.$http.post(api.getDepartmentTreeList, {}).then(res => {
          if (res.data.code == 0) {
            this.departmentData = res.data.data
            this.departmentData.forEach(v => {
              v.name = `${v.name}`
            })
          }
        })
      },
      search(){
        // this.handleNewParams()
        this.getList()
      },
      handleNewParams () {
        let params = {
          // control_ids: this.treeId || null,
          type: this.type
        }
        for (let key in this.searchForm) {
          if (this.searchForm[key]) {
            params[key] = this.searchForm[key]
          }
        }
        if (this.create_department === '') {
          this.create_department = null
        }
        if (this.Daterange != null && this.Daterange.length != 0) {
          params.begin_time = this.Daterange[0]
          params.end_time = this.Daterange[1]
        }else{
          params.begin_time = null
          params.end_time = null
        }
        if (params.control_id) {
          params.control_id = params.control_id[1]
        }
        return params
      },
      reset(){
        for(let i in this.searchForm){
          this.searchForm[i] = null
        }
        this.Daterange = []
      },
      handleCurrentChange (val) {
        this.getList(val)
      },
      change (val) {
        let data = this.$refs.departmentTree.getCheckedNodes(true)
        if(data && data.length>0){
          this.searchForm.create_department = data[0].data.name
        }else{
          this.searchForm.create_department = null
        }
      },
    }
  }
  </script>

  <style scoped>
    .el-table--striped .el-table__body tr.el-table__row--striped.current-row td,
    .el-table__body tr.current-row > td {
      background-color: #771e67;
    }
    .el-table--striped .el-table__body tr.hover-row.el-table__row--striped > td,
    .el-table__body tr.hover-row > td {
      background-color: #9f2f8a !important;
    }
    /* 用来设置当前页面element全局table 选中某行时的背景色*/
    ::v-deep .el-table__body tr.current-row>td{
      background-color: #f19944 !important;
      /* color: #f19944; */  /* 设置文字颜色，可以选择不设置 */
    }
    /* 用来设置当前页面element全局table 鼠标移入某行时的背景色*/
    ::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td {
      background-color: #f19944;
      /* color: #f19944; */ /* 设置文字颜色，可以选择不设置 */
    }
    ::v-deep .el-table__body tr.current-row>td {
      color: rgb(43, 5, 5);
      background: #7c4ba7!important;
      }
    .container {
      display: flex;
      padding-top: 20Px;
    }
    .span {
      font-size: 14Px;
      line-height: 32Px;
      margin:0 5Px 10Px 0;
    }
    .item {
      width: 160Px;
      margin:0 15Px 10Px 0;
    }
    .left {
      margin-left: 15Px;
    }
    .title {
      font-size: 18Px;
      font-weight: 900;
    }
    .fl-wrap {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }
    .mg-tp-sm {
      margin-top: 8Px;
    }
    .span {
      margin: 8Px;
    }
    .search-item {
      margin: 10Px 0;
    }
  </style>



// WEBPACK FOOTER //
// src/components/selectCheckList/selectCheckListDialog.vue